import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/elements/Properties/PropertyBookingWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/elements/Properties/PropertyCard/PropertyCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/elements/Properties/PropertyGalleryThumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/elements/Properties/PropertyLocation.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/elements/Properties/PropertyPerks.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/elements/Properties/ShareProperty.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/elements/Reviews/PropertyReviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/app/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/app/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
